exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._28UBAM-uVbAy-41n_yQOZo {\n  user-select: initial;\n}\n", ""]);

// exports
exports.locals = {
	"lineContent": "_28UBAM-uVbAy-41n_yQOZo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-1!./src/components/LineContent/index.module.css
// module id = 15
// module chunks = 0 1 2 4